import { gql } from '@apollo/client';
const GET_STORE = gql `
  query GetStore {
    isFilterbarVisible @client
    isAttachmentVisible @client
  }
`;
export default GET_STORE;
